// eslint-disable-next-line no-use-before-define
import React from 'react'

type Props = {
  value: number | string,
  km ?: boolean,
}
const DistanceInKm = ({ value, km } : Props) => (
  <>
    {value
      ? `${parseInt((km ? value : value as any / 1000) as string, 10).toLocaleString('US')} km`
      : ''}

  </>
)

export default React.memo(DistanceInKm)
